import React from 'react'

export function SectionTitle({ title, children }: { title?: string, children?: React.ReactNode }) {
  return (
    <div className="tw-uppercase tw-text-2xl tw-text-[#00506b] tw-font-semibold tw-border-0 tw-border-b-[3px] tw-border-solid tw-border-[#00506b] tw-pb-1 tw-mt-0 tw-mb-6">{title || children}</div>
  )
}